jQuery(function ($) {
  $(".accs-sel-wrapper .title").each(function () {
    let html = $(this).html();

    // Prevent double formatting
    if (html.includes("title-sub")) return;

    // Split into "Main title" + "(xxx)"
    let updated = html.replace(" (", '<br><span class="title-sub">(') + "</span>";

    $(this).html(updated);
  });
});


(() => {
  $(".select-wrapper .item").on("click", function () {
    $(this).siblings(".item").removeClass("active");
    $(this).addClass("active");
    const restock = $(this).attr('data-product-stock');
    const atcbutton = $(this).attr('data-product-atc');
    const stockindicator = $(this).attr('data-product-indicator');

    console.log(stockindicator);
    $('.product-restocks p b').text(restock);
    $('#initateCheckout').text(atcbutton);
    $('#currentSelection').attr("data-stocknum", stockindicator);

    $(".accs-sel-wrapper label").addClass("hide");
    $(
      `.accs-sel-wrapper label[data-product-id='${$(this).attr("data-product-id")}']`
    ).removeClass("hide");
    $(".accs-sel-wrapper label:not(.hide) input").first().trigger("change");

    $(".product-single__meta .main").text($(this).attr("data-product_title"));
    updateStockIndicator();
  });

  $(".accs-sel-wrapper input").on("change", function () {
    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", $(this).attr("data-price"));
    $("#currentSelection").attr("data-compare", $(this).attr("data-compare"));
    $(".product-single__thumbnails-items").removeClass("main").addClass("hide");
    $(`.product-single__thumbnails-items.${$(this).attr("data-handle")}`)
      .addClass("main")
      .removeClass("hide");
    $(
      `.product-single__thumbnails-items.${$(this).attr("data-handle")} a`
    ).addClass("active-thumb");
    $(".subtitle[data-variant_title]").html($(this).attr("data-variant_title") || "");
    // $(".variant_desc").html($(this).attr("data-variant_desc") || "");

    $(".accs-sel-wrapper input").prop("checked", false);
    $(this).prop("checked", true);

    const url = new URL(window.location.href);
    url.pathname = `/products/${$(this).attr("data-product_handle")}`;
    url.searchParams.set("variant", $(this).val());
    window.history.replaceState(null, "", url.toString());

    updateLinks();
    updatePrice();
    updateInstallment();
    updateThumbnail();
    console.log('acc selector');
  });

  $(".accs-sel-wrapper input:checked").trigger("change");
})();



